/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'
import Img from 'components/Img'
// import Logo from 'components/ui/Logo'

import Ratio from 'components/Ratio'

import ZoomPhoto from 'images/zoom.svg'


import './style'
import './media'

/*Images*/

const DocItem = props => (
    <div className={c("doc-item", props.className)} onClick={()=>props.onClick(props.link)}>
        <Ratio value={1.3}>
            <div className="doc-item__wrapp">
                <div className="doc-item__overlay">
                    <Img src={ZoomPhoto} className="zoom-photo"/>
                </div>
                {props.image}
            </div>
        </Ratio>   
    </div>
) 

export default DocItem